module.exports = __webpack_public_path__ + "img/cargo.b02a1b88.svg";